import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=6ac8a930&scoped=true"
import script from "./SendMessageForm.vue?vue&type=script&lang=js"
export * from "./SendMessageForm.vue?vue&type=script&lang=js"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&id=6ac8a930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8a930",
  null
  
)

export default component.exports